import { IconName, IconPrefix } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { EColors, EHovers } from 'libs/styles/styling';
import styled, { css } from 'styled-components/macro';

interface Props {
    iconSet?: IconPrefix;
    iconName?: IconName;
    text: string;
    onClick: (e: React.MouseEvent) => void;
    highlighted?: boolean;
    className?: string;
    inline?: boolean;
}

export const CustomActionButton = (props: Props): JSX.Element => {
    return (
        <S_CustomActionButton
            className={props.className}
            onClick={props.onClick}
            $highlighted={props.highlighted}
            $inline={props.inline}
        >
            {props.iconName && (
                <S_Icon $inline={props.inline} icon={[props.iconSet ?? 'fal', props.iconName]} />
            )}
            <S_Text>{props.text}</S_Text>
        </S_CustomActionButton>
    );
};

const S_CustomActionButton = styled.div<{ $inline: boolean; $highlighted: boolean }>`
    display: flex;
    flex-direction: column;
    justify-content: center;
    cursor: pointer;
    color: ${EColors.ALMOST_BLACK};
    user-select: none;
    background: #fff;
    align-items: center;
    user-select: none;
    white-space: nowrap;
    padding: 0 10px;
    &:hover {
        background: ${EColors.GREY2};
        box-shadow: ${EHovers.LIGHT1};
    }
    ${(props) => {
        if (props.$highlighted) {
            return css`
                background: ${EColors.GREY3};
                &:hover {
                    background: ${EColors.GREY3};
                }
            `;
        }
        if (props.$inline) {
            return css`
                flex-direction: row;
            `;
        }
    }}
`;

const S_Icon = styled(FontAwesomeIcon)<{ $inline: boolean }>`
    font-size: 13px;
    margin: 0 0 13px 0;
    ${(props) => {
        if (props.$inline) {
            return css`
                margin: 0 13px 0px 0;
            `;
        }
    }}
`;

const S_Text = styled.div`
    font-size: 13px;
`;
